<template>
  <Card :class="['cmp', 'cmp-tab-works']">
    <!-- <div slot="header">
      <el-row type="flex">
        <el-col :span="18" class="left">
          <strong>{{title}}</strong>
        </el-col>
        <el-col :span="6" class="right text-right">
          <label v-if="userInfo.type==='STUDENT'"
            class="el-button el-button--primary"
          >上传作业
            <input class="hide" type="file" @change="fileChange" />
          </label>
        </el-col>
      </el-row>
    </div> -->
    <el-row slot="header" type="flex" align="center">
      <div class="row-left">
        <h3>{{ title }}</h3>
        <p>{{ projectWorksDetails.content }}</p>
      </div>
      <div class="row-right">
        <label v-if="userInfo.type === 'STUDENT'" class="el-button el-button--primary"
          >上传作业
          <input class="hide" type="file" @change="fileChange" />
        </label>
      </div>
    </el-row>
    <div slot="body">
      <!-- <pre class="works-topic">{{projectWorksDetails.content}}</pre> -->
      <div class="works-list">
        <template v-for="(v, i) in myProjectWorks">
          <studentCard1 v-if="v.type !== 'seat'" :data="v" :key="i"></studentCard1>
          <div v-else class="seat" :key="i"></div>
        </template>
        <div v-if="myProjectWorks.length === 0" class="nodata nodata-works"></div>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <div slot="footer">未提交的同学有 ：{{ projectWorksUndo.join("、") || "无" }}</div>
  </Card>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Card from "@/components/cmpCard.vue";
import studentCard1 from "./student-card-1.vue";
import publicUrl from "@/assets/js/interface";
import utils from "@/assets/js/utils.js";
import ossUtil from "@/assets/js/ossUtil.js";

export default {
  name: "cmp-tab-works",
  components: {
    Card,
    studentCard1,
  },
  data() {
    return {
      projectWorksDetails: {
        content: "",
        submitType: "",
        workType: "",
        tableStr: "",
        id: "",
        projectId: this.$route.query.projectId,
      },
      projectWorks: [],
      projectWorksUndo: [],
      resourceKey: "",
      resourceSrc: "",
      resourceName: "",
      pageSize: 10,
      currentPage: 1,
      total: 0,
      loadingCount: 0,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
    ...mapGetters({
      classActive: "classmanagement/classActive",
      submitTypeDict: "submitTypeDict",
      workTypeDict: "workTypeDict",
    }),
    myProjectWorks() {
      let arr = [...this.projectWorks];
      let colCount = 4;
      return utils.listWith(arr, colCount);
    },
    title() {
      let submitTypeLabel = (this.submitTypeDict[this.projectWorksDetails.submitType] || {}).label || "";
      let workTypeLabel = (this.workTypeDict[this.projectWorksDetails.workType] || {}).label || "";
      return `${submitTypeLabel}作品 - ${workTypeLabel}作品`;
    },
  },
  created() {
    this.getProjectDetails();
    this.getProjectWorks();
    this.getProjectWorksUndo();
  },
  methods: {
    getProjectDetails() {
      this.loadingCount++;
      this.projectWorksDetails = {
        content: "",
        submitType: "",
        type: "",
        tableStr: "",
        id: "",
        projectId: this.$route.query.projectId,
      };
      return this.$ajax
        .get(publicUrl.projectWorksDetails, {
          params: {
            projectId: this.$route.query.projectId,
          },
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.projectWorksDetails = {
              ...this.projectWorksDetails,
              ...(res.data.data || {}),
            };
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    getProjectWorks() {
      this.loadingCount++;
      this.projectWorks = [];
      this.$ajax
        .get(publicUrl.projectWorks, {
          params: {
            classId: this.classActive.id,
            pageNo: this.currentPage,
            pageSize: this.pageSize,
            projectId: this.$route.query.projectId,
          },
        })
        .then((res) => {
          if (res.data.code === 0) {
            let _data = res.data.data || {};
            this.projectWorks = _data.result || [];
            this.total = _data.totalCount || 0;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    getProjectWorksUndo() {
      this.loadingCount++;
      this.projectWorksUndo = [];
      this.$ajax
        .get(publicUrl.projectWorksUndo, {
          params: {
            classId: this.classActive.id,
            projectId: this.$route.query.projectId,
          },
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.projectWorksUndo = res.data.data || [];
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getProjectWorks();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getProjectWorks();
    },
    fileChange(e) {
      if (!e.target.files) {
        return;
      }
      if (e.target.files.length) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        ossUtil
          .upload(
            e.target.files[0],
            {
              onUploadProgress: function(e) {
                const progress = Math.ceil((e.loaded / e.total) * 100);
                loading.text = progress + "%";
              },
            },
            false
          )
          .then((res) => {
            this.resourceKey = res.resourceKey;
            this.resourceSrc = res.url;
            this.resourceName = e.target.files[0].name;
            this.submitProjectWork();
          })
          .catch((err) => {
            this.$message.error("文件上传失败");
            this.$ajaxError(err);
          })
          .finally(() => {
            loading.close();
          });
      }
    },
    submitProjectWork() {
      this.loadingCount++;
      this.$ajaxJson
        .post(publicUrl.submitProjectWork, {
          ...this.projectWorksDetails,
          fileKey: this.resourceKey,
          fileName: this.resourceName,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.$message.success("提交成功" || res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.cmp-tab-works {
  .el-row {
    line-height: 40px;
    .row-left {
      width: 0;
      flex-grow: 1;
      h3 {
        font-size: 16px;
        color: #464c5b;
        line-height: 22px;
      }
      p {
        font-size: 16px;
        font-weight: normal;
        color: #657180;
        line-height: 22px;
      }
    }
    .row-right {
    }
  }
  .works-topic {
    text-indent: 2em;
    line-height: 1.5;
    margin-bottom: 15px;
    white-space: pre-wrap;
  }
  .works-list {
    display: flex;
    flex-wrap: wrap;
    .work-item {
      width: 276px;
      margin: 10px auto;
      border-radius: 6px;
      box-shadow: 0px 4px 8px 0px rgba(134, 144, 167, 0.3);
      overflow: hidden;
      .top {
        height: 253px;
        background: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          display: block;
          width: 126px;
          height: 126px;
          border: 1px solid #ced2da;
          border-radius: 50%;
        }
        .username {
          height: 28px;
          font-size: 20px;
          color: #464c5b;
          line-height: 28px;
        }
        .el-tag {
          margin: 0 10px;
          i {
            margin-right: 0.5em;
          }
        }
      }
      .bottom {
        height: 42px;
        background: #ececec;
      }
    }
    .seat {
      width: 276px;
      height: 1px;
      visibility: hidden;
    }
  }
  .right {
    font-size: 16px;
    font-weight: normal;
    color: #9ea7b4;
  }
  .el-pagination {
    text-align: center;
  }
  .x-star-bar {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
}
</style>
